// 获取最终的状态信息
export const resturantName = state => state.resturantName+'xuxian_name'
export const title = state => state.title+'xuxian_title'
